export default "__VITE_ASSET__6ae12c6a__"